import { Component, h, Host, Element, Prop, State } from "@stencil/core";

/**
 * @slot title - Slot for the title/headline
 * @slot copy - Slot for the description text
 * @slot link - Slot for the link element
 */
@Component({
    tag: "ux-iws-nb-contact-tile",
    styleUrl: "nb-contact-tile.scss",
    shadow: true,
})
export class NbContactTile {
    @Element() host: HTMLUxIwsNbContactTileElement;

    /** Background image URL */
    @Prop() image: string;
    /** Use wide layout that spans full width */
    @Prop() wide: boolean = false;

    @State() linkHref: string = "";
    @State() linkTarget: string = "";
    @State() linkRel: string = "";
    @State() linkLabel: string = "";

    connectedCallback() {
        this.modifyLink();
    }

    private modifyLink() {
        const linkElement = this.host.querySelector(
            'a[slot="link"]'
        ) as HTMLAnchorElement;
        if (!linkElement) return;
        if (linkElement.querySelector("ux-icon")) return;

        const icon = document.createElement("ux-icon");
        icon.setAttribute("name", "arrow-right");
        linkElement.appendChild(icon);
    }

    render() {
        return (
            <Host
                class={{
                    "is-wide": this.wide,
                }}
            >
                <ux-iws-link-wrapper
                    linkElement={this.host.querySelector('a[slot="link"]')}
                >
                    <div
                        class="tile-container"
                        style={{
                            backgroundImage: this.image
                                ? `url(${this.image})`
                                : undefined,
                        }}
                    >
                        <div class="gradient-overlay"></div>
                        <div class="content">
                            <div class="text-content">
                                <div class="title-container">
                                    <slot name="title" />
                                </div>
                                <div class="copy-container">
                                    <slot name="copy" />
                                </div>
                            </div>
                            <div class="link-container">
                                <slot name="link" />
                            </div>
                        </div>
                    </div>
                </ux-iws-link-wrapper>
            </Host>
        );
    }
}
